<section class="tw-rounded-3 tw-mx-4 tw-px-2 tw-py-3 tw-border-2 tw-border-solid tw-border-teal-200 tw-box-border tw-cursor-pointer"
         style="background: linear-gradient(95deg, #E4F4F0 -6.23%, #FFF 88%);"
         (click)="onClick()">
  <div class="tw-flex tw-items-center">
    <cs-icon class="tw-h-12 tw-w-12" [iconName]="'order_received'"></cs-icon>
    <div class="tw-ml-2 tw-flex tw-flex-col tw-min-h-12 tw-gap-1">
      <div class="tw-flex tw-items-center">
        <p class="tw-leading-4 tw-font-body tw-font-bold tw-text-300 tw-items-center tw-flex tw-pt-1" i18n="@@orderConfirmationPending">
          Order Confirmation Pending
        </p>
        <cs-icon class="tw-pt-1 tw-h-5 tw-w-5 tw-pl-2" [iconName]="'chevron_right_teal'"></cs-icon>
      </div>
      <p class="tw-leading-tight tw-font-body tw-text-gray-500 tw-font-medium tw-text-200 tw-items-center tw-flex" i18n="@@consentNeededBeforeShip">
        Consent needed before we ship
      </p>
    </div>
  </div>
</section>
